// it is added as a class name to nodes whose scrollHeight value is used by activating auto-height option.
export const CHARTKIT_SCROLLABLE_NODE_CLASSNAME = 'chartkit-scrollable-node';

export const CHARTKIT_ERROR_NODE_CLASSNAME = 'datalens-chartkit-error';

export const CHARTKIT_MAIN_CLASSNAME = 'chartkit';

export const TABLE_DYNAMIC_MIN_SIZE = 300;
